export const BulkOperationStatusEnum = {
  Pending: {
    key: "pending",
    value: "pending",
  },
  Validating: {
    key: "validating",
    value: "validating",
  },
  Validated: {
    key: "validated",
    value: "validated",
  },
  InProgress: {
    key: "in_progress",
    value: "in_progress",
  },
  Done: {
    key: "done",
    value: "done",
  },
  Failed: {
    key: "failed",
    value: "failed",
  },
};
